var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatriciaSellerLanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 644,
    viewBox: "0 0 498 644",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275 5.05894e-07L249.035 2.69516e-06L249 0L248.965 2.70099e-06L243 5.05902e-07V0.0820318C244.982 0.0276577 246.97 0.000314725 248.965 2.70099e-06L249.035 2.69516e-06C368.864 0.0186854 466 97.1658 466 217C466 336.846 368.846 434 249 434C246.993 434 244.993 433.973 243 433.918L243 644H275L275 433.918C276.993 433.973 278.993 434 281 434C400.846 434 498 336.846 498 217C498 97.1543 400.845 -1.01048e-05 281 0C278.993 1.69209e-07 276.993 0.0273441 275 0.0820318V5.05894e-07ZM32.0001 644L32 1.82965e-05L0 3.65929e-05L5.43135e-05 644H32.0001ZM63.9999 644H211L211 433.918C212.993 433.973 214.993 434 217 434C336.846 434 434 336.846 434 217C434 97.1543 336.846 8.21374e-06 217 1.82965e-05C214.993 1.82965e-05 212.993 0.0273624 211 0.0820501V1.82965e-05H63.9998L63.9999 644Z",
    fill: "url(#paint0_radial_8779_161907)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8779_161907",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217 -1.84402e-05) rotate(90) scale(644 434)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#18161B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#948E9E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatriciaSellerLanding);
export default __webpack_public_path__ + "static/media/patricia-seller-landing.2fbeb244.svg";
export { ForwardRef as ReactComponent };